export default {
  googleMapApiKey: "AIzaSyA5IZSXRWd1hW7Kj-yRwoFeyo-X_8__mKY",
  googleMeasurementId: "GTM-NFWXC3MQ"
}
